// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* HTML DataTable Styles - Modern & Beautiful */

.html-data-table-container {
  width: 100%;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

/* Controls Bar */
.html-data-table-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  flex-wrap: wrap;
  gap: 12px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-bottom: 1px solid #e9ecef;
}

.entries-per-page {
  display: flex;
  align-items: center;
  gap: 8px;
}

.entries-select {
  padding: 6px 12px;
  border: 1px solid #dee2e6;
  background: white;
  font-size: 13px;
  color: #495057;
  cursor: pointer;
  min-width: 70px;
  border-radius: 6px;
  transition: all 0.2s ease;
  font-weight: 500;
}

.entries-select:hover {
  border-color: #1976d2;
  box-shadow: 0 2px 4px rgba(25, 118, 210, 0.1);
}

.entries-select:focus {
  outline: none;
  border-color: #1976d2;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);
}

.entries-label {
  font-size: 13px;
  color: #6c757d;
  white-space: nowrap;
  font-weight: 500;
}

.search-container {
  width: 100%;
  max-width: 250px;
  margin-left: auto;
}

.search-input {
  width: 100%;
  padding: 8px 14px;
  border: 1px solid #dee2e6;
  font-size: 13px;
  border-radius: 8px;
  transition: all 0.2s ease;
  background: white;
}

.search-input:focus {
  outline: none;
  border-color: #1976d2;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);
}

.search-input::placeholder {
  color: #adb5bd;
}

/* Table Wrapper */
.html-data-table-wrapper {
  overflow-x: auto;
  border-radius: 12px;
}

.html-data-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: white;
}

.html-data-table thead th {
  padding: 14px 16px;
  font-weight: 600;
  font-size: 13px;
  color: #212529;
  text-align: left;
  border-bottom: 2px solid #e9ecef;
  white-space: nowrap;
  position: relative;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 11px;
}

.html-data-table thead th:first-child {
  border-top-left-radius: 12px;
}

.html-data-table thead th:last-child {
  border-top-right-radius: 12px;
}

.html-data-table thead th.sortable-header {
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.html-data-table thead th.sortable-header:hover {
  background: linear-gradient(135deg, #e9ecef 0%, #f8f9fa 100%);
  color: #1976d2;
}

/* Allow React elements in header and cells to handle their own clicks */
.html-data-table thead th > *,
.html-data-table tbody td > * {
  pointer-events: auto;
}

.html-data-table thead th > div,
.html-data-table tbody td > div {
  pointer-events: auto;
  min-height: 1px; /* Ensure divs are visible */
}

/* Ensure React elements are visible */
.html-data-table thead th > div > *,
.html-data-table tbody td > div > * {
  pointer-events: auto;
  visibility: visible;
  display: block;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  width: 100%;
}

.sort-icon {
  font-size: 12px;
  color: #adb5bd;
  margin-left: 6px;
  transition: color 0.2s ease;
}

.sort-asc,
.sort-desc {
  color: #1976d2;
  font-weight: bold;
}

.html-data-table tbody tr {
  border-bottom: 1px solid #f1f3f5;
  transition: all 0.2s ease;
  background: white;
}

.html-data-table tbody tr:nth-child(even) {
  background: #fafbfc;
}

.html-data-table tbody tr:hover {
  background-color: #f0f7ff !important;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.08);
}

.html-data-table tbody tr:hover td:not(.date-column) {
  background-color: transparent !important;
}

.html-data-table tbody td {
  padding: 14px 16px;
  font-size: 13px;
  color: #495057;
  vertical-align: middle;
  transition: all 0.2s ease;
  line-height: 1.5;
}

.html-data-table tbody td.no-end-border {
  border-bottom: none;
}

.no-data {
  text-align: center;
  padding: 48px 16px !important;
  color: #adb5bd;
  font-style: italic;
  font-size: 14px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
}

/* Footer */
.html-data-table-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  flex-wrap: wrap;
  gap: 16px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-top: 1px solid #e9ecef;
  border-radius: 0 0 12px 12px;
}

.total-entries {
  font-size: 13px;
  color: #6c757d;
  font-weight: 500;
}

/* Pagination */
.pagination {
  display: flex;
  align-items: center;
  gap: 2px;
}

.pagination-btn {
  min-width: 36px;
  height: 36px;
  padding: 0 12px;
  border: 1px solid #dee2e6;
  background: white;
  color: #495057;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.pagination-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-color: #1976d2;
  color: #1976d2;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(25, 118, 210, 0.15);
}

.pagination-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  background: #f8f9fa;
}

.pagination-btn.active {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  color: white;
  border-color: #1976d2;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.3);
}

.page-input {
  width: 50px;
  height: 36px;
  padding: 0 8px;
  border: 1px solid #dee2e6;
  text-align: center;
  font-size: 13px;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.page-input:focus {
  outline: none;
  border-color: #1976d2;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);
}

/* Responsive Design */
@media (max-width: 768px) {
  .html-data-table-controls {
    flex-direction: column;
    align-items: stretch;
  }

  .entries-per-page {
    width: 100%;
  }

  .search-container {
    width: 100%;
    max-width: 100%;
    margin-left: 0;
  }

  .html-data-table-footer {
    flex-direction: column;
    align-items: stretch;
  }

  .total-entries {
    text-align: center;
  }

  .pagination {
    justify-content: center;
    flex-wrap: wrap;
  }

  .html-data-table {
    font-size: 12px;
  }

  .html-data-table thead th,
  .html-data-table tbody td {
    padding: 6px 8px;
  }
}

/* Print Styles */
@media print {
  .html-data-table-controls,
  .html-data-table-footer {
    display: none;
  }

  .html-data-table {
    border: 1px solid #000;
  }

  .html-data-table thead th {
    background: #f5f5f5 !important;
    color: #000 !important;
    border-bottom: 1px solid #000;
  }
}
`, "",{"version":3,"sources":["webpack://./src/examples/Tables/HTMLDataTable/styles.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA,wEAAwE;AACxE;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;EACpB,eAAe,EAAE,4BAA4B;AAC/C;;AAEA,sCAAsC;AACtC;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,6DAA6D;AAC/D;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,SAAS;EACT,6DAA6D;EAC7D,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;AACF;;AAEA,iBAAiB;AACjB;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;IAC9B,sBAAsB;IACtB,6BAA6B;EAC/B;AACF","sourcesContent":["/* HTML DataTable Styles - Modern & Beautiful */\n\n.html-data-table-container {\n  width: 100%;\n  background: #fff;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n}\n\n/* Controls Bar */\n.html-data-table-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  flex-wrap: wrap;\n  gap: 12px;\n  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);\n  border-bottom: 1px solid #e9ecef;\n}\n\n.entries-per-page {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.entries-select {\n  padding: 6px 12px;\n  border: 1px solid #dee2e6;\n  background: white;\n  font-size: 13px;\n  color: #495057;\n  cursor: pointer;\n  min-width: 70px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  font-weight: 500;\n}\n\n.entries-select:hover {\n  border-color: #1976d2;\n  box-shadow: 0 2px 4px rgba(25, 118, 210, 0.1);\n}\n\n.entries-select:focus {\n  outline: none;\n  border-color: #1976d2;\n  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);\n}\n\n.entries-label {\n  font-size: 13px;\n  color: #6c757d;\n  white-space: nowrap;\n  font-weight: 500;\n}\n\n.search-container {\n  width: 100%;\n  max-width: 250px;\n  margin-left: auto;\n}\n\n.search-input {\n  width: 100%;\n  padding: 8px 14px;\n  border: 1px solid #dee2e6;\n  font-size: 13px;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  background: white;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #1976d2;\n  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);\n}\n\n.search-input::placeholder {\n  color: #adb5bd;\n}\n\n/* Table Wrapper */\n.html-data-table-wrapper {\n  overflow-x: auto;\n  border-radius: 12px;\n}\n\n.html-data-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  background: white;\n}\n\n.html-data-table thead th {\n  padding: 14px 16px;\n  font-weight: 600;\n  font-size: 13px;\n  color: #212529;\n  text-align: left;\n  border-bottom: 2px solid #e9ecef;\n  white-space: nowrap;\n  position: relative;\n  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-size: 11px;\n}\n\n.html-data-table thead th:first-child {\n  border-top-left-radius: 12px;\n}\n\n.html-data-table thead th:last-child {\n  border-top-right-radius: 12px;\n}\n\n.html-data-table thead th.sortable-header {\n  user-select: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.html-data-table thead th.sortable-header:hover {\n  background: linear-gradient(135deg, #e9ecef 0%, #f8f9fa 100%);\n  color: #1976d2;\n}\n\n/* Allow React elements in header and cells to handle their own clicks */\n.html-data-table thead th > *,\n.html-data-table tbody td > * {\n  pointer-events: auto;\n}\n\n.html-data-table thead th > div,\n.html-data-table tbody td > div {\n  pointer-events: auto;\n  min-height: 1px; /* Ensure divs are visible */\n}\n\n/* Ensure React elements are visible */\n.html-data-table thead th > div > *,\n.html-data-table tbody td > div > * {\n  pointer-events: auto;\n  visibility: visible;\n  display: block;\n}\n\n.header-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 4px;\n  width: 100%;\n}\n\n.sort-icon {\n  font-size: 12px;\n  color: #adb5bd;\n  margin-left: 6px;\n  transition: color 0.2s ease;\n}\n\n.sort-asc,\n.sort-desc {\n  color: #1976d2;\n  font-weight: bold;\n}\n\n.html-data-table tbody tr {\n  border-bottom: 1px solid #f1f3f5;\n  transition: all 0.2s ease;\n  background: white;\n}\n\n.html-data-table tbody tr:nth-child(even) {\n  background: #fafbfc;\n}\n\n.html-data-table tbody tr:hover {\n  background-color: #f0f7ff !important;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.08);\n}\n\n.html-data-table tbody tr:hover td:not(.date-column) {\n  background-color: transparent !important;\n}\n\n.html-data-table tbody td {\n  padding: 14px 16px;\n  font-size: 13px;\n  color: #495057;\n  vertical-align: middle;\n  transition: all 0.2s ease;\n  line-height: 1.5;\n}\n\n.html-data-table tbody td.no-end-border {\n  border-bottom: none;\n}\n\n.no-data {\n  text-align: center;\n  padding: 48px 16px !important;\n  color: #adb5bd;\n  font-style: italic;\n  font-size: 14px;\n  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);\n}\n\n/* Footer */\n.html-data-table-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px;\n  flex-wrap: wrap;\n  gap: 16px;\n  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);\n  border-top: 1px solid #e9ecef;\n  border-radius: 0 0 12px 12px;\n}\n\n.total-entries {\n  font-size: 13px;\n  color: #6c757d;\n  font-weight: 500;\n}\n\n/* Pagination */\n.pagination {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.pagination-btn {\n  min-width: 36px;\n  height: 36px;\n  padding: 0 12px;\n  border: 1px solid #dee2e6;\n  background: white;\n  color: #495057;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n.pagination-btn:hover:not(:disabled) {\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border-color: #1976d2;\n  color: #1976d2;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(25, 118, 210, 0.15);\n}\n\n.pagination-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  background: #f8f9fa;\n}\n\n.pagination-btn.active {\n  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);\n  color: white;\n  border-color: #1976d2;\n  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.3);\n}\n\n.page-input {\n  width: 50px;\n  height: 36px;\n  padding: 0 8px;\n  border: 1px solid #dee2e6;\n  text-align: center;\n  font-size: 13px;\n  border-radius: 8px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.page-input:focus {\n  outline: none;\n  border-color: #1976d2;\n  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .html-data-table-controls {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .entries-per-page {\n    width: 100%;\n  }\n\n  .search-container {\n    width: 100%;\n    max-width: 100%;\n    margin-left: 0;\n  }\n\n  .html-data-table-footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .total-entries {\n    text-align: center;\n  }\n\n  .pagination {\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n\n  .html-data-table {\n    font-size: 12px;\n  }\n\n  .html-data-table thead th,\n  .html-data-table tbody td {\n    padding: 6px 8px;\n  }\n}\n\n/* Print Styles */\n@media print {\n  .html-data-table-controls,\n  .html-data-table-footer {\n    display: none;\n  }\n\n  .html-data-table {\n    border: 1px solid #000;\n  }\n\n  .html-data-table thead th {\n    background: #f5f5f5 !important;\n    color: #000 !important;\n    border-bottom: 1px solid #000;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
